<template>
  <b-modal @hide="modalClose" ref="createModal" :title="$t('製品登録')" size="xl">
    <b-container fluid>
      <table class="table table-bordered mb-5">
        <tbody class="tbody">
          <tr class>
            <th class="table-active text-left" width="150">
              {{ $t('品番') }}
              <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
            </th>
            <td class="text-left" width="200">
              <div class="input-group w-100 position-relative">
                <input v-model="form.code" type="search" class="form-control input" autocomplete="on" @input="filterProductCode" :disabled="disabled" @focus="mixinListToggle('productList', true)" @blur="mixinListToggle('productList', false)" />
                <div class="input-group-append">
                  <button class="btn btn-light" type="button"
                  @click="disabledRelease()"
                  >選択解除</button>
                </div>
                <div id="productList" class="list-group searchList" style="display:none">
                  <a v-for="(item,index) in this.products" :key="index" @click="existProduct(item)" class="list-group-item list-group-item-action">{{ item.code }}/{{ item.name }}</a>
                </div>
              </div>
            </td>
            <th class="table-active text-left" width="150">
              {{ $t('改訂') }}
            </th>
            <td width="200">
              {{ form.version || '-'}}
            </td>
            <th class="table-active text-left" width="150">{{ $t('品名') }}</th>
            <td width="200">
              {{ form.name || '-'}}
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t('製品種別') }}
            </th>
            <td>
              <div class="form-check form-check-inline" v-if="form.type === 'ownbrand'">{{ $t("内製品") }}</div>
              <div class="form-check form-check-inline" v-else-if="form.type === 'purchase'">{{ $t("仕入品") }}</div>
              <div class="form-check form-check-inline" v-else-if="form.type === 'material'">{{ $t("材料") }}</div>
              <div class="form-check form-check-inline" v-else>-</div>
            </td>
            <th class="table-active text-left">
              {{ $t('図番') }}
            </th>
            <td>{{ form.figureNo || '-' }}</td>
            <th class="table-active text-left">{{ $t('RoHS指令対応') }}</th>
            <td class>
              <span v-if="form.isRoHS">{{ $t('対応') }}</span>
              <span v-else>{{ $t('非対応') }}</span>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left" v-if="form.type !== 'ownbrand'">
              {{ $t('メーカー') }}
            </th>
            <td v-if="form.type !== 'ownbrand'">
              {{ form.supplier || '-' }}
            </td>
          </tr>
          <tr class>
            <th class="table-active text-left">
              {{ $t('数量') }}
              <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
            </th>
            <td class="text-left">
              <input v-model.number="form.quantity" type="number" min="0" class="form-control input" />
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { debounce } from 'lodash'
import { mapGetters } from 'vuex'
const form = {
  type: '',
  code: '',
  name: '',
  figureNo: '',
  version: '',
  isRoHS: false,
  supplier: '',
  outputLevel: '',
  salesPrice: null,
  purchasePrice: null,
  shapeType: '',
  shapeValues: [],
  shapeWeight: null,
  note: '',
  shapeNote: '',
}
const structureForm = {
  quantity: null,
  productId: null,
  structures: [],
}
export default {
  props: {
    productId: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        type: '',
        code: '',
        name: '',
        figureNo: '',
        version: '',
        isRoHS: false,
        supplier: '',
        outputLevel: '',
        salesPrice: null,
        purchasePrice: null,
        shapeType: '',
        shapeValues: [],
        shapeWeight: null,
        note: '',
        shapeNote: '',
      },
      structureForm: {
        quantity: null,
        productId: null,
        structures: [],
      },
      error: '',
      registering: false,
      disabled: false,
      products: [],
      parentProductIds: [],
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(ids = []) {
      this.$refs.createModal.show()
      ids.map(id => {
        this.parentProductIds.push(id)
      })
      try {
        this.products = await this.getProducts()
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
        this.$refs.createModal.hide()
      }
    },
    destroyModal() {
      this.registering = false
      this.form = this.mixin_deepcopy(form)
      this.structureForm = this.mixin_deepcopy(structureForm)
      this.disabled = false
      this.error = ''
      this.products = []
      this.parentProductIds = []
      this.$refs.createModal.hide()
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.destroyModal()
      this.$emit('modalClose')
    },
    // 製品寸法が変更されたらそれにともなって製品寸法の値の数を変更
    shapeTypeChange() {
      if (this.form.shapeType === 'round') {
        this.form.shapeValues = [0, 0]
      } else if (this.form.shapeType == 'corner' || this.form.shapeType == 'plate') {
        this.form.shapeValues = [0, 0, 0]
      } else {
        this.form.shapeType = []
      }
    },
    // 既存の製品を選んだ時のその製品を代入する処理
    existProduct(item) {
      this.form = this.mixin_deepcopy(item)
      const item_keys = [
        'code', 'version', 'type', 'figureNo', 'isRoHS', 'supplier',
      ]
      const product = this.getProduct(item.id)
      for (const item_key in item_keys) {
        this.form[item_key] = product[item_key]
      }
      this.disabled = true
    },
    // 選択解除のボタンを押下した時のid削除
    disabledRelease() {
      if (this.disabled) delete this.form.id
      this.disabled = false
    },
    // 登録処理
    async register() {
      if (this.isEmpty(this.form.id))
        return (this.error = this.$t('品番') + this.$t('必須メッセージ'))
      if (this.isEmpty(this.form.quantity))
        return (this.error = this.$t('数量') + this.$t('必須メッセージ'))
      if (this.form.quantity <= 0)
        return (this.error = this.$t('数量を0以上の数字で入力して下さい'))
      this.structureForm.productId = this.form.id
      this.structureForm.quantity = this.form.quantity
      this.$emit('registed', this.structureForm)
      this.destroyModal()
    },
    async getProducts(code = '') {
      /** DBマスタデータを取得する。 */
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/products`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          params: {
            code: code,
            limit: 50,
          },
        },
      )
      if (res === null || res.status !== 200) {
        return []
      }
      return res.data
    },
    async getProduct(productId) {
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/product`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          params: {
            id: productId,
          },
        },
      )
      if (res === null || res.status !== 200) {
        return {}
      }
      return res.data
    },
    filterProductCode: debounce(async function(e) {
      this.products = await this.getProducts(e.target.value)
    }, 500),
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
<style lang="scss">
.searchList {
  height: 300px;
  overflow: auto;
}
</style>
